import { includes, pull, concat, pullAll, flatten, uniq, clone } from "lodash"
import { includeArray } from "utils/util"

type SwitchArrayType = <T>(arr: Array<T>, id: T) => Array<T>
export const switchArrayType: SwitchArrayType = (arr, id) =>
  includes(arr, id) ? pull(clone(arr), id) : concat(clone(arr), id)

type SwitchArray = <T>(arr: Array<T>, addArr: Array<T>) => Array<T>
export const switchArray: SwitchArray = (arr, addArr) => {
  if (includeArray(arr, addArr)) {
    return pullAll(clone(arr), addArr)
  } else {
    return uniq(flatten(concat(clone(arr), addArr)))
  }
}
